import React, { FunctionComponent } from 'react'
import { MaintenanceAndSupportStatus } from '../../Customer/Data'
import { AccountIcon, WarningIcon } from '../../Icons/Icons'
import styles from './AccountSummary.module.css'

interface Props {
  onClick: () => void
  isOpen: boolean
  dataAvailable: boolean
  badge: string
}

const AccountSummary: FunctionComponent<Props> = props => {
  let statusClass = ''
  let accountText = ''
  if (props.dataAvailable) {
    switch (props.badge) {
      case MaintenanceAndSupportStatus.Current:
      case MaintenanceAndSupportStatus.Expired:
      case MaintenanceAndSupportStatus.Expiring:
        statusClass = props.badge.toLowerCase()
        accountText = 'M&S ' + statusClass
        break
      case 'NFR':
      case 'Trial':
        statusClass = 'license'
        accountText = props.badge + ' license'
        break
    }
  } else {
    statusClass = 'warning'
  }

  const onClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    if (props.dataAvailable) {
      props.onClick()
    }
  }

  return (
    <li className={`${styles.featurePanel}` + (props.isOpen ? ' active' : '')}>
      <a href='#tab-account' onClick={onClick}>
        <div className='title'>Account</div>
        <div className={`status ` + statusClass}>
          <i className='icon'>
            <AccountIcon />
          </i>
          {!props.dataAvailable && (
            <div className='label'>
              <span className='state'>
                <i className='icon twelve'>
                  <WarningIcon />
                </i>
              </span>
              Data not available
            </div>
          )}
          <span className='state'>{accountText}</span>
        </div>
      </a>
    </li>
  )
}

export default AccountSummary
